import { translateRestImmutableIdsToEwsIds, ConvertIdSource } from 'owa-immutable-id';
import getMailItemByItemId from './getMailItemByItemId';

export default async function getMailItemByImmutableId(restImmutableId: string) {
    const translationResponse = await translateRestImmutableIdsToEwsIds(
        [restImmutableId],
        ConvertIdSource.BoardMailItem
    )[0];
    const id = translationResponse.TargetId;
    if (id) {
        return getMailItemByItemId(id);
    }

    const errorCode = translationResponse.ErrorDetails?.Code;
    if (errorCode == 'NotFound') {
        return null;
    }

    throw new Error(errorCode);
}
